export const compareStrings = (a, b) => a.toLowerCase() === b.toLowerCase()
